import { useEffect, useState } from 'react';
import { buildAppStatusState, type AppStatusPayload, type AppStatusState } from '../lib/app-status';
import { appStatusSource } from '../lib/app-status-source';
import { CURRENT_YEAR } from '../styles/tokens';

const DEFAULT_STATUS = buildAppStatusState(null, CURRENT_YEAR);

export function useAppStatus(): AppStatusState {
  const [status, setStatus] = useState<AppStatusPayload | null>(() => appStatusSource.getSnapshot().status);

  useEffect(() => {
    const unsubscribe = appStatusSource.subscribe(() => {
      setStatus(appStatusSource.getSnapshot().status);
    });

    void appStatusSource.load().catch(() => {});

    return unsubscribe;
  }, []);

  return status ? buildAppStatusState(status, CURRENT_YEAR) : DEFAULT_STATUS;
}
